module.exports = __webpack_public_path__ + "img/info.ec66beb2.svg";